<div class="container-fluid">
  <div class="row form-row">
    <h2 class="col-sm-12">
      {{ 'revenue.credit-card-charge.title' | translate | titlecase }}
    </h2>
  </div>
  <div class="row form-row">
    <div class="col-sm-2">
      {{ 'common.revenue.invoice-number' | translate | titlecase }}
    </div>
    <div class="col-sm-3">
      <!--<input type="number" class="form-control" [(ngModel)]="invoiceNumber" style="text-align: right"/>-->
      <wl-invoice-lookup #invoiceLookup [(ngModel)]="invoiceNumber" (onInvoiceChanged)="onInvoiceChanged($event)"></wl-invoice-lookup>
    </div>
    <div class="col-sm-7"></div>
  </div>

  <div class="row form-row">
    <div class="col-sm-2">
      {{ 'revenue.credit-card-charge.select-payment-type' | translate | titlecase }}
    </div>
    <div class="col-sm-4">
      <select
        class="form-control"
        [(ngModel)]="selectedPaymentTypeId"
        (ngModelChange)="onPaymentTypeChange($event)"
        [disabled]="selectedPaymentTypeId == null || selectedPaymentTypeId == 0"
      >
        <option
          *ngFor="let paymentType of paymentTypes"
          [value]="paymentType.PaymentTypeId"
          [selected]="selectedPaymentTypeId == paymentType.PaymentTypeId ? true : null"
        >
          {{ paymentType.PaymentType }}
        </option>
      </select>
    </div>
    <div class="col-sm-6"></div>
  </div>
  <div class="row form-row">
    <div class="col-sm-2"></div>
    <div class="col-sm-4">
      <div *ngIf="message > ''">
        <div class="alert alert-danger">
          {{ message | titlecase }}
        </div>
      </div>
    </div>
    <div class="col-sm-6"></div>
  </div>

  <!--<div class="row form-row">
        <div class="col-sm-2">
            {{'revenue.credit-card-charge.select-gateway'|translate|titlecase}}
        </div>
        <div class="col-sm-4">
            <select class="form-control" [(ngModel)]="selectedGatewayId" (ngModelChange)="onGatewayChange($event)" disabled>
                <option *ngFor="let gateway of cardGateways" [value]="gateway.CCGatewayID" [selected]="selectedGatewayId == gateway.CCGatewayID ? true: null">
                    {{gateway.Name}}
                </option>
            </select>
        </div>
        <div class="col-sm-6">
        </div>

    </div>-->

  <div class="row form-row">
    <div class="col-sm-2">
      {{ 'common.revenue.amount' | translate | titlecase }}
    </div>
    <div class="col-sm-3">
      <!--<input type="number" min="0.00" step="0.01" class="form-control" disabled [(ngModel)]="amountToCharge" style="text-align: right"/>-->
      <label>{{ amountToCharge | currency }}</label>
    </div>
    <div class="col-sm-7"></div>
  </div>

  <hr />
  <div class="row form-row">
    <!--<div class="col-sm-2">

        </div>-->
    <div class="col-sm-8">
      <div class="row form-row">
        <wl-busy [show]="isProcessing"></wl-busy>
      </div>
      <div class="row">
        <wl-credit-card-input #creditCardInput [resolvedGateway]="resolvedGateway"></wl-credit-card-input>
      </div>
      <div class="row form-row"></div>
      <div class="row form-row">
        <wl-busy [show]="isProcessing"></wl-busy>
      </div>
      <div class="row form-row">
        <!--<div>{{result}}</div>-->
      </div>
    </div>
    <div class="col-sm-4"></div>
  </div>
  <div class="row form-row">
    <div class="col-sm-2"></div>
    <div class="col-sm-2">
      <button pButton type="button" class="btn btn-primary" (click)="processCard()" [disabled]="!isValid()">
        {{ 'common.process' | translate | titlecase }}
      </button>
    </div>
    <div class="col-sm-2">
      <button pButton type="button" class="btn btn-primary" (click)="clearForm()">{{ 'common.clear' | translate | titlecase }}</button>
    </div>
    <div class="col-sm-6"></div>
  </div>
</div>
